const itemsDataReducer = (data = "unset", action) => {
    switch(action.type){
        case 'SET_ITEMS_DATA':
            data = action.data
            return data;
        default:
            return data;
    }
}

export default itemsDataReducer;